import styles from './SessionLogout.module.scss';
import { NexusModal } from '@nexus/react';
import { useAppDispatch } from '../../../store';
import { useEffect, useState } from 'react';
import ButtonComponent from '../../components/nds/button/button';
import LoaderComponent from '../../components/nds/loader/loader';
import { invalidatePrallelSessions } from '../../../store/customSlice/userProfileSlice';
import { setUserPopupMessage } from '../../../store/customSlice/authSlice';

interface SessionLogoutProps {
    handleLogout: () => void;
}
const SessionLogout = (props: SessionLogoutProps) => {
    const [isLoaderShow, setIsLoaderShow] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setIsLoaderShow(false);
    }, []);

    const logoutCurrentSession = () => {
        setIsLoaderShow(false);
        props.handleLogout();
    };

    const logoutAllSession = () => {
        setIsLoaderShow(false);
        //call API to logout all sessions and keep current session active
        dispatch(invalidatePrallelSessions()).then(() => {
            dispatch(setUserPopupMessage(false));
            window.location.reload();
        });
    };

    return (
        <>
            <NexusModal
                className={styles['modal-element'] + ' ' + styles['session-overlay']}
                data-testid='pricacy-policy-modal'
                id='modal'
                show={true}
                fullscreen={false}
                size={'lg'}
            >
                <div className={styles['modal-scroll']}>
                    <div className={styles['modal-header']}>
                        <div className={styles['risk-header']}>
                            <div className={`${styles['page-header-font']} nexus-h3 nexus-pb-2`}>Multiple sessions</div>
                        </div>
                    </div>

                    <div className={styles['modal-container']} data-testid='modal-body'>
                        <p>
                            Multiple sessions detected. For security reasons, please confirm if you would like to log
                            out of the current session or Keep this session and logout of other sessions.
                        </p>
                        <div className={styles['btn-container'] + ' nexus-col-lg-6 nexus-pb-4'}>
                            <div className='nexus-pr-2'>
                                <ButtonComponent
                                    type={'primary'}
                                    label={'Logout of this session'}
                                    onClick={logoutCurrentSession}
                                    disabled={false}
                                ></ButtonComponent>
                            </div>
                            <div>
                                <ButtonComponent
                                    type={'primary-alt'}
                                    title={'Keep this session, logout of other sessions'}
                                    label={'Keep this session, logout of other sessions'}
                                    onClick={logoutAllSession}
                                    disabled={false}
                                    width={230}
                                ></ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </NexusModal>
            <LoaderComponent show={isLoaderShow} fullscreen={true} />
        </>
    );
};

export default SessionLogout;
